<template>
	<div ng-controller="kingdomTributesCtrl" class="tributes">
		<!-- ngIf: player.isKingdomLeader() && tributeVillages.length > 0 -->
		<!-- ngIf: player.isKingdomLeader() && dukeVillages.length > 0 -->
		<!-- ngIf: player.isKingdomLeader() && foreignVillages.length > 0 -->
		<!-- ngIf: (player.isKing() || player.isViceKing()) && !isEmpty(independentVillages) -->
		<div ng-include="" src="'tpl/society/partials/kingdom/tributes/ownVillages.html'">
			<div class="ownVillages statisticsTable contentBox transparent" ng-controller="ownVillagesCtrl">
				<h6 ng-if="ownVillages.data.length > 0" class="contentBoxHeader headerWithArrowEndings tableGreen">
					<div class="content" translate=""><span>Отказаться от дани</span></div>
				</h6>
				<table ng-if="ownVillages.data.length > 0" class="gradient">
					<thead>
						<tr>
							<th><i class="community_kingdom_small_flat_black"></i></th>
							<th><i class="village_village_small_flat_black"></i></th>
							<th>
								<i class="movement_tribute_small_flat_black"></i>
								<div class="symbol_i_tiny_wrapper">
									<i class="symbol_i_tiny_flat_white" content="Деревни без сокровищницы должны платить дань ближайшему королю, вице-королю или герцогу. Ты можешь отказаться это делать, но соответствующему игроку придет об этом уведомление. Так что принимай во внимание возможные последствия этого шага." v-tippy="{placement: 'bottom'}" tooltip-translate="Kingdom.TributeOverview.DenyTributeInfo"></i>
								</div>
							</th>
						</tr>
					</thead>
					<tbody class="ranks">
						<tr ng-repeat="village in ownVillages.data | orderBy: 'data.name'">
							<td class="playerColumn villageList">
								<avatar-image class="avatarImage" player-id="172" scale="0.5" avatar-class="profileImage">
									<div class="heroImage  profileImage male" ng-class="::class" rerender="rerender">
										<!-- ngIf: playerId == robberId -->
										<!-- ngIf: playerId == npcGovernorId -->
										<canvas width="62" height="62"></canvas>
									</div>
								</avatar-image>
								<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="villageName playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="172">Царевич</a>
								<div class="meta">
									<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable disabled" clickable="$root.openWindow('kingdom', {'kingdomId': 3}, null, true)" nolink="true" kingdomid="3">MИР</a>
								</div>
							</td>
							<td class="villageColumn">
								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536330229}, null, true)" village-link="" villageid="536330229" villagename="Брест">Брест</a>
							</td>
							<td class="denyTributes">
								<div only-progress="true" village="village">
									<div class="collectTributesContainer">
										<div ng-if="village.data.allowTributeCollection" class="tributeBar" ng-style="{opacity: (troopMovement.time > currentServerTime && !animation.collect) ? 0 : 1}" tooltip="" tooltip-class="tributesProductionTooltip" tooltip-url="tpl/society/partials/kingdom/tributes/tributesProductionTooltip.html" style="opacity: 1;">
											<div class="progressbar" progressbar="" type="green" perc="3" marker="20" steps="20" value-interpolation="true" interpolation-threshold="0.2" interpolation-duration="0.4" interpolation-curve="ease-in" on-interpolation-end="animation.collect = false">
												<!-- ngIf: ::labelIcon -->
												<div class="progress">
													<div ng-if="steps" class="stepContainer">
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 0%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 5%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 10%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 15%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 20%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 25%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 30%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 35%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 40%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 45%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 50%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 55%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 60%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 65%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 70%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 75%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 80%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 85%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 90%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 95%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 100%;"></div>
													</div>
													<div class="bar positive perc  green" style="z-index: 2; width: 3%;"></div>
													<div class="bar additionalBar additionalPerc"></div>
													<div class="marker" style="z-index: 3; width: 20%;">
														<div class="markerInner"></div>
													</div>
													<!-- ngIf: ::showCountdown -->
													<!-- ngIf: ::label -->
													<!-- ngIf: ::percTooltip -->
												</div>
											</div>
											<!-- ngIf: village.data.tributeTreasures > 0 && !onlyProgress -->
										</div>
										<!-- ngIf: !village.data.allowTributeCollection -->
										<!-- ngIf: !village.data.allowTributeCollection && !onlyProgress -->
										<!-- ngIf: (!(troopMovement.time > currentServerTime) || animation.collect) && village.data.allowTributeCollection  && !onlyProgress -->
										<!-- ngIf: troopMovement.time > currentServerTime && !animation.collect && !onlyProgress -->
									</div>
								</div>
								<switch switch-name1="" switch-name2="" switch-callback="toggleDenyTributes" switch-model="village.data.allowTributeCollection" switch-id="village.data.villageId">
									<label class="clickInputLabel">
										<!-- ngIf: switchName1 != '' -->
										<div class="clickInputWrapper switchBox switchedOn" ng-class="{switchedOn: switch}">
											<div class="switchButtonWrapper">
												<input type="checkbox" class="switch ng-pristine ng-untouched ng-valid" ng-disabled="switchDisabled" ng-model="switch" ng-change="switchChanged()">
												<i ng-class="{action_check_tiny_flat_black: switch, action_cancel_tiny_flat_black: !switch}" class="action_check_tiny_flat_black"></i>
											</div>
										</div>
										<!-- ngIf: switchName2 != '' -->
									</label>
								</switch>
							</td>
						</tr>
						<tr ng-repeat="village in ownVillages.data | orderBy: 'data.name'">
							<td class="playerColumn villageList">
								<avatar-image class="avatarImage" player-id="172" scale="0.5" avatar-class="profileImage">
									<div class="heroImage  profileImage male" ng-class="::class" rerender="rerender">
										<!-- ngIf: playerId == robberId -->
										<!-- ngIf: playerId == npcGovernorId -->
										<canvas width="62" height="62"></canvas>
									</div>
								</avatar-image>
								<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="villageName playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="172">Царевич</a>
								<div class="meta">
									<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable disabled" clickable="$root.openWindow('kingdom', {'kingdomId': 3}, null, true)" nolink="true" kingdomid="3">MИР</a>
								</div>
							</td>
							<td class="villageColumn">
								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536264691}, null, true)" village-link="" villageid="536264691" villagename="Глушица">Глушица</a>
							</td>
							<td class="denyTributes">
								<div only-progress="true" village="village">
									<div class="collectTributesContainer">
										<div ng-if="village.data.allowTributeCollection" class="tributeBar" ng-style="{opacity: (troopMovement.time > currentServerTime && !animation.collect) ? 0 : 1}" tooltip="" tooltip-class="tributesProductionTooltip" tooltip-url="tpl/society/partials/kingdom/tributes/tributesProductionTooltip.html" style="opacity: 1;">
											<div class="progressbar" progressbar="" type="green" perc="2" marker="20" steps="13" value-interpolation="true" interpolation-threshold="0.2" interpolation-duration="0.4" interpolation-curve="ease-in" on-interpolation-end="animation.collect = false">
												<!-- ngIf: ::labelIcon -->
												<div class="progress">
													<div ng-if="steps" class="stepContainer">
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 0%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 7.69231%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 15.3846%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 23.0769%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 30.7692%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 38.4615%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 46.1538%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 53.8462%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 61.5385%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 69.2308%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 76.9231%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 84.6154%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 92.3077%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 100%;"></div>
													</div>
													<div class="bar positive perc  green" style="z-index: 2; width: 2%;"></div>
													<div class="bar additionalBar additionalPerc"></div>
													<div class="marker" style="z-index: 3; width: 20%;">
														<div class="markerInner"></div>
													</div>
													<!-- ngIf: ::showCountdown -->
													<!-- ngIf: ::label -->
													<!-- ngIf: ::percTooltip -->
												</div>
											</div>
											<!-- ngIf: village.data.tributeTreasures > 0 && !onlyProgress -->
										</div>
										<!-- ngIf: !village.data.allowTributeCollection -->
										<!-- ngIf: !village.data.allowTributeCollection && !onlyProgress -->

										<!-- ngIf: (!(troopMovement.time > currentServerTime) || animation.collect) && village.data.allowTributeCollection  && !onlyProgress -->
										<!-- ngIf: troopMovement.time > currentServerTime && !animation.collect && !onlyProgress -->
									</div>
								</div>
								<switch switch-name1="" switch-name2="" switch-callback="toggleDenyTributes" switch-model="village.data.allowTributeCollection" switch-id="village.data.villageId">
									<label class="clickInputLabel">
										<!-- ngIf: switchName1 != '' -->
										<div class="clickInputWrapper switchBox switchedOn" ng-class="{switchedOn: switch}">
											<div class="switchButtonWrapper">
												<input type="checkbox" class="switch ng-pristine ng-untouched ng-valid" ng-disabled="switchDisabled" ng-model="switch" ng-change="switchChanged()">
												<i ng-class="{action_check_tiny_flat_black: switch, action_cancel_tiny_flat_black: !switch}" class="action_check_tiny_flat_black"></i>
											</div>
										</div>
										<!-- ngIf: switchName2 != '' -->
									</label>
								</switch>
							</td>
						</tr>
						<tr ng-repeat="village in ownVillages.data | orderBy: 'data.name'">
							<td class="playerColumn villageList">
								<avatar-image class="avatarImage" player-id="172" scale="0.5" avatar-class="profileImage">
									<div class="heroImage  profileImage male" ng-class="::class" rerender="rerender">
										<!-- ngIf: playerId == robberId -->
										<!-- ngIf: playerId == npcGovernorId -->
										<canvas width="62" height="62"></canvas>
									</div>
								</avatar-image>
								<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="villageName playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="172">Царевич</a>
								<div class="meta">
									<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable disabled" clickable="$root.openWindow('kingdom', {'kingdomId': 3}, null, true)" nolink="true" kingdomid="3">MИР</a>
								</div>
							</td>
							<td class="villageColumn">
								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536264692}, null, true)" village-link="" villageid="536264692" villagename="Зарница">Зарница</a>
							</td>
							<td class="denyTributes">
								<div only-progress="true" village="village">
									<div class="collectTributesContainer">
										<div ng-if="village.data.allowTributeCollection" class="tributeBar" ng-style="{opacity: (troopMovement.time > currentServerTime && !animation.collect) ? 0 : 1}" tooltip="" tooltip-class="tributesProductionTooltip" tooltip-url="tpl/society/partials/kingdom/tributes/tributesProductionTooltip.html" style="opacity: 1;">
											<div class="progressbar" progressbar="" type="green" perc="10" marker="20" steps="16" value-interpolation="true" interpolation-threshold="0.2" interpolation-duration="0.4" interpolation-curve="ease-in" on-interpolation-end="animation.collect = false">
												<!-- ngIf: ::labelIcon -->
												<div class="progress">
													<div ng-if="steps" class="stepContainer">
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 0%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 6.25%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 12.5%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 18.75%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 25%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 31.25%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 37.5%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 43.75%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 50%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 56.25%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 62.5%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 68.75%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 75%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 81.25%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 87.5%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 93.75%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 100%;"></div>
													</div>
													<div class="bar positive perc  green" style="z-index: 2; width: 10%;"></div>
													<div class="bar additionalBar additionalPerc"></div>
													<div class="marker" style="z-index: 3; width: 20%;">
														<div class="markerInner"></div>
													</div>
													<!-- ngIf: ::showCountdown -->
													<!-- ngIf: ::label -->
													<!-- ngIf: ::percTooltip -->
												</div>
											</div>
											<!-- ngIf: village.data.tributeTreasures > 0 && !onlyProgress -->
										</div>
										<!-- ngIf: !village.data.allowTributeCollection -->
										<!-- ngIf: !village.data.allowTributeCollection && !onlyProgress -->
										<!-- ngIf: (!(troopMovement.time > currentServerTime) || animation.collect) && village.data.allowTributeCollection  && !onlyProgress -->
										<!-- ngIf: troopMovement.time > currentServerTime && !animation.collect && !onlyProgress -->
									</div>
								</div>
								<switch switch-name1="" switch-name2="" switch-callback="toggleDenyTributes" switch-model="village.data.allowTributeCollection" switch-id="village.data.villageId">
									<label class="clickInputLabel">
										<!-- ngIf: switchName1 != '' -->
										<div class="clickInputWrapper switchBox switchedOn" ng-class="{switchedOn: switch}">
											<div class="switchButtonWrapper">
												<input type="checkbox" class="switch ng-pristine ng-untouched ng-valid" ng-disabled="switchDisabled" ng-model="switch" ng-change="switchChanged()">
												<i ng-class="{action_check_tiny_flat_black: switch, action_cancel_tiny_flat_black: !switch}" class="action_check_tiny_flat_black"></i>
											</div>
										</div>
										<!-- ngIf: switchName2 != '' -->
									</label>
								</switch>
							</td>
						</tr>
						<tr ng-repeat="village in ownVillages.data | orderBy: 'data.name'">
							<td class="playerColumn villageList">
								<avatar-image class="avatarImage" player-id="127" scale="0.5" avatar-class="profileImage">
									<div class="heroImage  profileImage male" ng-class="::class" rerender="rerender">
										<!-- ngIf: playerId == robberId -->
										<!-- ngIf: playerId == npcGovernorId -->
										<canvas width="62" height="62"></canvas>
									</div>
								</avatar-image>
								<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="villageName playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="127">Gaius Ulius</a>
								<div class="meta">
									<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable disabled" clickable="$root.openWindow('kingdom', {'kingdomId': 3}, null, true)" nolink="true" kingdomid="3">Roman</a>
								</div>
							</td>
							<td class="villageColumn">
								<a ng-class="{disabled: villId <= 2 || nolink}" class="villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 537182205}, null, true)" village-link="" villageid="537182205" villagename="InZectorsk">InZectorsk</a>
							</td>
							<td class="denyTributes">
								<div only-progress="true" village="village">
									<div class="collectTributesContainer">
										<div ng-if="village.data.allowTributeCollection" class="tributeBar" ng-style="{opacity: (troopMovement.time > currentServerTime && !animation.collect) ? 0 : 1}" :content="tooltips[1]" v-tippy="{placement: 'bottom'}" tooltip-class="tributesProductionTooltip" tooltip-url="tpl/society/partials/kingdom/tributes/tributesProductionTooltip.html" style="opacity: 1;">
											<div class="progressbar" progressbar="" type="green" perc="0" marker="20" steps="3" value-interpolation="true" interpolation-threshold="0.2" interpolation-duration="0.4" interpolation-curve="ease-in" on-interpolation-end="animation.collect = false">
												<!-- ngIf: ::labelIcon -->
												<div class="progress">
													<div ng-if="steps" class="stepContainer">
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 0%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 33.3333%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 66.6667%;"></div>
														<div class="progressbarStep" ng-repeat="n in [] | range:0:steps" ng-style="{width: (n/steps*100) + '%'}" style="width: 100%;"></div>
													</div>
													<div class="bar positive perc  green" style="z-index: -1; width: 0%;"></div>
													<div class="bar additionalBar additionalPerc"></div>
													<div class="marker" style="z-index: 3; width: 20%;">
														<div class="markerInner"></div>
													</div>
													<!-- ngIf: ::showCountdown -->
													<!-- ngIf: ::label -->
													<!-- ngIf: ::percTooltip -->
												</div>
											</div>
											<!-- ngIf: village.data.tributeTreasures > 0 && !onlyProgress -->
										</div>
										<!-- ngIf: !village.data.allowTributeCollection -->
										<!-- ngIf: !village.data.allowTributeCollection && !onlyProgress -->

										<!-- ngIf: (!(troopMovement.time > currentServerTime) || animation.collect) && village.data.allowTributeCollection  && !onlyProgress -->
										<!-- ngIf: troopMovement.time > currentServerTime && !animation.collect && !onlyProgress -->
									</div>
								</div>
								<switch switch-name1="" switch-name2="" switch-callback="toggleDenyTributes" switch-model="village.data.allowTributeCollection" switch-id="village.data.villageId">
									<label class="clickInputLabel">
										<!-- ngIf: switchName1 != '' -->
										<div class="clickInputWrapper switchBox switchedOn" ng-class="{switchedOn: switch}">
											<div class="switchButtonWrapper">
												<input type="checkbox" class="switch ng-pristine ng-untouched ng-valid" ng-disabled="switchDisabled" ng-model="switch" ng-change="switchChanged()">
												<i ng-class="{action_check_tiny_flat_black: switch, action_cancel_tiny_flat_black: !switch}" class="action_check_tiny_flat_black"></i>
											</div>
										</div>
										<!-- ngIf: switchName2 != '' -->
									</label>
								</switch>
							</td>
						</tr>
					</tbody>
				</table>
				<!-- ngIf: dataLoaded && independentVillages.length === 0 && tributeVillages.length === 0 && dukeVillages.length === 0 && foreignVillages.length === 0 && ownVillages.data.length === 0 -->
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		tooltips: {
			1: `<h3>Дань</h3>
			<div class='horizontalLine'></div>
			<div class='capacity'><i class='unit_resources_small_illu'></i>3 / 2300</div>
			<div class='horizontalLine'></div>
			<div class='display-resources productionRow'>
				<div class='costs max1digits'>
					<span class='resource woodValue'>
						<i class='unit_wood_small_illu resType1'></i>
						<span class='production'><span>5/ч</span></span>
					</span>
					<span class='resource clayValue'>
						<i class='unit_clay_small_illu resType2'></i>
						<span class='production'><span>5/ч</span></span>
					</span>
					<span class='resource ironValue'>
						<i class='unit_iron_small_illu resType3'></i>
						<span class='production'><span>5/ч</span></span>
					</span>
				</div>
			</div>`,
		},
	}),
	computed: {},
	methods: {},
	components: {},
}
</script>